import React, { useState } from 'react';

import ToggleSelector from '../../../../SidePropertiesContainer/components/ToggleSelector/ToggleSelector';

import arrowDown from '../../../../../../../../../../../assets/img/arrow-down.svg';
import editPencilIcon from '../../../../../../../../../../../assets/img/edit-black.svg';

import styles from './GroupAndRandomiseChildHeader.module.css';
import Icon from '../../../../../../Icon/Icon';
import DuplicateAction from './components/DuplicateAction/DuplicateAction';

/* eslint-disable-next-line */
const GroupName = ({ setGroupNameRef, group, actions }) => {
  const [changeName, setChangeName] = useState(false);

  return (
    <input
      ref={r => setGroupNameRef(r)}
      className={`${styles.groupName} ${
        changeName ? styles.changeGroupName : styles.blurGroupName
      }`}
      value={group.label}
      size={group.label ? group.label.length : 0}
      onChange={e =>
        actions.updateGroupProperty(group.id, 'label', e.target.value)
      }
      onFocus={e => {
        setChangeName(true);
        e.target.select();
      }}
      onBlur={e => {
        e.target.blur();
        e.target.selectionStart = 0;
        e.target.selectionEnd = 0;
        setChangeName(false);

        //
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === 'Tab') {
          e.preventDefault();
          e.target.blur();
        }
      }}
      placeholder="Add label - invisible to respondents"
    />
  );
};

export default function({
  setGroupNameRef,
  group,
  actions,
  surveyListGroup,
  expanded,
  setExpanded
}) {
  return (
    <div className={styles.container}>
      <img
        className={styles.icon}
        src={editPencilIcon}
        alt="Group And Randomise Icon"
      />
      <GroupName
        setGroupNameRef={setGroupNameRef}
        group={group}
        actions={actions}
      />
      <div className={styles.randomizeToogleContainer}>
        <ToggleSelector
          label="Randomise groups"
          customParentStyle={styles.toogleSelector}
          customLabelStyle={styles.toogleSelectorLabel}
          labelPositionRight
          onChange={() =>
            actions.updateGroupProperty(
              group.id,
              'randomized',
              !group.randomized
            )
          }
          value={group.randomized}
        />
      </div>
      <div
        className={
          group && group.flows && group.flows.length <= 1
            ? `${styles.duplicateContainer} ${
                styles.duplicateContainerDisabled
              }`
            : styles.duplicateContainer
        }
      >
        <DuplicateAction
          isActionAllowed={{ allowed: true }}
          onActionClick={() => {
            if (
              surveyListGroup &&
              surveyListGroup.parentGroup &&
              surveyListGroup.parentGroup.id &&
              group &&
              group.flows &&
              group.flows.length > 1
            ) {
              actions.duplicateGroup(
                group,
                null,
                null,
                null,
                surveyListGroup.parentGroup.id
              );
            }
          }}
          icon={<Icon type="duplicate" className={styles.duplicateIcon} />}
          label="Duplicate"
        />
      </div>
      <div
        className={styles.expandArrowContainer}
        role="presentation"
        onClick={() => {
          setExpanded(!expanded);
        }}
      >
        <img
          className={
            !expanded ? styles.expandArrowImg : styles.collapseArrowImg
          }
          src={arrowDown}
          alt="Expand collapse"
        />
      </div>
    </div>
  );
}
